export default __webpack_public_path__ + "static/gradient-pattern-46e9cece5724310099170d532cfd3a56.png";